// This should really be an enum, but flow does not support them out of the
// box, and we are not using Typescript yet.
export const ScribeCorrectionModeUnset = '';
export const ScribeCorrectionModeFast = 'fast';
export const ScribeCorrectionModeAccurate = 'accurate';
export const ScribeCorrectionModeDefault = ScribeCorrectionModeFast;
